import { createApp } from 'vue'
import { createPinia } from 'pinia'
import App from './App.vue'
import router from './router'
import { captureAttribution } from '@/utils/attribution'

const app = createApp(App)
const pinia = createPinia()

app.use(pinia)
app.use(router)

// 在首次路由完成后捕获归因参数（UTM + invite_code）
router.isReady().then(() => {
  const query = router.currentRoute.value.query
  captureAttribution(query)
})

app.mount('#app')